import React, { useContext, useState } from 'react';
import { AccountContext } from '../../context';
import { IBLSpinLoader } from '../../../IBLSpinLoader';
import { useTranslation } from 'react-i18next';

const Security = () => {
  const { userData, handlePassWordForgotten } = useContext(AccountContext);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const { t } = useTranslation('library');

  const handlePasswordResetCallback = (data) => {
    setLoading(false);
    setNotification({
      success: true,
      message: t('Password reset link sent!'),
    });
  };

  const handleErrCallback = () => {
    setLoading(false);
    setNotification({
      error: true,
      message: t('Something went wrong. Please try again later!'),
    });
  };

  return (
    <div
      data-name="security"
      className="manage-account-form-block mt-top-added w-form"
    >
      <form
        id="email-form-2"
        name="email-form-2"
        data-name="Email Form 2"
        method="get"
        className="manage-account-form security-account-form"
        data-wf-page-id="65aec9c9e13ed74d8bfffe77"
        data-wf-element-id="af75e9f0-f6d7-98f4-9c2b-f0690b382ff7"
      >
        <div className="w-layout-hflex-account-ui tabs-content align-right more-gap">
          <h5 className="heading">{t('Reset Password')}</h5>
          <div className="text-block-53">
            {t('Click to reset your password.')}
          </div>
          <div className="w-layout-hflex-account-ui flex-block-20">
            <a
              onClick={
                !loading
                  ? () => {
                      setNotification({});
                      setLoading(true);
                      handlePassWordForgotten(
                        handlePasswordResetCallback,
                        handleErrCallback
                      );
                    }
                  : () => {}
              }
              href="#"
              className={`default-btn form-submit-btn no-width w-button ${
                loading && 'password-reset-loading'
              }`}
            >
              <span>{t('Send Password Reset Link')}</span>{' '}
              {loading && (
                <div style={{ width: '40px' }}>
                  <IBLSpinLoader size={20} color={'#FFF'} />
                </div>
              )}
            </a>
          </div>
          {!!notification?.message && (
            <div className={`pwd-notification-container`}>
              <div
                className={`pwd-notification-text ${
                  notification?.success ? 'success' : 'error'
                }`}
              >
                {notification?.message}
              </div>
            </div>
          )}
        </div>
      </form>
      <div className="w-form-done">
        <div>{t('Thank you! Your submission has been received!')}</div>
      </div>
      <div className="w-form-fail">
        <div>{t('Oops! Something went wrong while submitting the form.')}</div>
      </div>
    </div>
  );
};

export default Security;
